import React from 'react';
import { EditorialCard } from '../../helpers/list-page/interfaces/list-card.interface';
import Link from 'next/link';
import { getTagBorderColor } from '@/helpers/tailwindColors';

interface CardEditorialItemProps {
  card: EditorialCard;
  cardIndex: number;
  fixedWidth?: boolean;
}

export const CardEditorialItem = ({
  card,
  cardIndex,
  fixedWidth = false,
}: CardEditorialItemProps) => {
  return (
    <div className="relative">
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group relative flex aspect-0.75/1 cursor-pointer flex-col overflow-hidden rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light ${fixedWidth && 'w-[276px]'}`}
      >
        {card?.image?.url && (
          <img
            className="!absolute inset-0  aspect-0.75/1 transition-all object-cover block w-full"
            src={card?.image?.url + '?fm=webp&q=50'}
            alt={card?.image?.alt || 'alt text not found'}
          />
        )}

        <div className="relative flex h-full flex-col justify-end bg-gradient-to-t from-transparency-overlay-solid transition-all duration-200 ease-in-out lg:group-hover:bg-transparency-backdrop">
          <div className="flex flex-col gap-3 pb-6 px-5">
            <h2 className="font-title text-headingm text-brand-white transition-all duration-200 ease-in-out lg:group-hover:text-brand-yellow-1">
              {card?.name}
            </h2>
            {card?.tags && card.tags.length > 0 && (
              <div className="flex flex-wrap content-end items-end gap-2">
                {card.tags.map((tag, key) => (
                  <span
                    key={key}
                    className={`inline-flex h-5 flex-shrink-0 items-center rounded-[4px] border-2 bg-background-primary-light px-2 text-bodyxs font-bold text-text-default ${getTagBorderColor(tag.colour)}`}
                  >
                    {tag.tagName}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
